var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoTextDark = function SvgLogoNoTextDark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_616_3370",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 202,
    height: 202
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202 0H0V202H202V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_616_3370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.878 0H57.1219C25.5743 0 0 25.5743 0 57.1219V144.878C0 176.426 25.5743 202 57.1219 202H144.878C176.426 202 202 176.426 202 144.878V57.1219C202 25.5743 176.426 0 144.878 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.501 43C63.164 43 48 66.4285 48 100.926C48 135.423 63.164 160 101.501 160C139.838 160 155 135.421 155 100.926C155 66.4303 139.838 43 101.501 43ZM101.506 141.095C84.0205 141.095 74.9643 130.834 72.2308 113.564C72.0249 112.262 73.0207 111.079 74.3342 111.079H128.408C129.717 111.079 130.712 112.255 130.514 113.555C127.855 130.83 118.997 141.095 101.508 141.095H101.506ZM74.107 92.3522C72.813 92.3522 71.8243 91.2019 71.9983 89.9124C74.423 71.9521 83.4915 61.9055 101.506 61.9055C119.521 61.9055 128.382 71.9557 130.735 89.9213C130.904 91.2072 129.917 92.3522 128.625 92.3522H74.107Z",
    fill: "#06003C"
  }))));
};
export default SvgLogoNoTextDark;